module.exports = __webpack_public_path__ + "static/media/ios14-iphone11-pro-settings-sn.fd061486.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios14-iphone11-pro-settings-sn.png
// module id = 977
// module chunks = 0